// console.log(1234);
//import axios from 'axios';

// import {userLoginAPI,sendVerificationAPI2API} from '@/api/api'
//按需加载
import {
  userLoginAPI,
  getUserProjects,
  getCaptchaCode,
  checkCaptchaCode,
  getSmsCaptchaResult,
  getPhoneSmsCaptcha,
  getLoginUser,
  getSmsCaptcha,
} from "../../api/api";

// const Captcha = () => import('../../components/identify/captcha/Captcha.vue');
import Captcha from "../../components/identify/captcha/Captcha.vue";
import Password from "@/views/password/Modify.vue";
let captchaToken;
let isBlur = false;
export default {
  name: "login",
  data() {
    //密码登录 验证规则
    const validateUser = (rule, value, callback) => {
      if (value === "" && !isBlur) {
        callback(new Error("请输入账户"));
      } else {
        callback();
      }
    };
    const validatePass = (rule, value, callback) => {
      if (value === "" && !isBlur) {
        callback(new Error("请输入密码"));
      } else {
        callback();
      }
    };
    // 验证码自定义验证规则
    const validateVerifycode = (rule, value, callback) => {
      if (value === "" && !isBlur) {
        callback(new Error("请输入正确的验证码"));
      } else {
        callback();
      }
    };

    // 验证码自定义验证规则
    const validateVerifycode2 = (rule, value, callback) => {
      if (value === "" && !isBlur) {
        callback(new Error("请先输入正确的验证码"));
      } else {
        callback();
      }
    };

    //短信登录 验证规则
    // const validatePhone = (rule, value, callback) => {
    //   if (value === "" && !isBlur) {
    //     callback(new Error("请输入您的手机号"));
    //   } else {
    //     if (isBlur) {
    //       return callback();
    //     }
    //     const reg = /^0?((1[3-9])|(9[0-9]))[0-9]{9}$/;
    //     if (reg.test(value)) {
    //       return callback();
    //     }
    //     callback("请输入合法的手机号");
    //   }
    // };
    var validatePhone = (rule, value, callback) => {
      var re = /^1[3,4,5,6,7,8,9][0-9]{9}$/;
      var result = re.test(value);
      if (!result) {
        callback(new Error("请输入正确的手机号"));
        return false; //若手机号码格式不正确则返回false
      } else {
        callback();
      }
    };

    const validatePhoneCode = (rule, value, callback) => {
      if (value === "" && !isBlur) {
        callback(
          new Error("请输入您点击右侧“获取短信验证码”按钮后收到的短信验证码")
        );
      } else {
        if (isBlur) {
          return callback();
        }
        const reg = /^[0-9]{6}$/;
        if (reg.test(value)) {
          return callback();
        }
        callback("请输入正确的短信验证码");
      }
    };

    return {
      ruleForm: {
        user: "",
        pass: "",
        verifycode: "",
      },
      rules: {
        user: [
          {
            required: true,
            validator: validateUser,
            trigger: "blur",
          },
        ],
        pass: [
          {
            required: true,
            validator: validatePass,
            trigger: "blur",
          },
        ],
        verifycode: [
          {
            required: true,
            validator: validateVerifycode,
            trigger: "blur",
          },
        ],
      },
      phoneRuleForm: {
        user: "",
        pass: "",
        phoneCode: "",
        // verifycode2: "",
      },
      phoneRules: {
        user: [
          // {
          //   required: true,
          //   validator: validatePhone,
          //   trigger: "blur",
          // },
          {
            required: true,
            message: "请输入账号",
            trigger: "blur",
          },
        ],
        pass: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
        ],
        phoneCode: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur",
          },
        ],
        // verifycode2: [
        //   {
        //     required: true,
        //     validator: validateVerifycode2,
        //     trigger: "blur",
        //   },
        // ],
      },
      captchaImage: "",
      isLogin: false,
      icon: "el-input__icon el-icon-view",
      phoneIcon: "el-input__icon el-icon-view",
      passw: "password",
      phoneRuleFormPassw: "password",
      activeName: "second",
      activeNameOl: "first",
      dialogVisible: true, // 对话框显示和隐藏
      valiBtn: "获取短信验证码",
      disabled: false,
      disabled2: false, //禁用短信验证码登录里的随机验证码输入框。
      codeTimer: "", //用于取消倒计时动画

      phoneCode: "", //存储后端返回的手机验证码，前端验证通过后再向后端发送数据验证。
      expirationPrompt: false, //验证码是否过期。
      expirationTimer: null, //保存验证码计时器。
      nowTime: 120,
      isShowSmsLoginTab: true,

      phoneNumber: "", //用户手机号
      iframeUrl: `https://jjt.ccccltd.cn/wwopen/sso/qrConnect?appid=wl2c5e89d5c4&agentid=1002720&redirect_uri=${window.location.origin}/scanCode&state=1&login_type=jssdk&version=3.0.31000.109&platform=win&href=${window.location.origin}/css/wwlogincode.css`,
      VueAppBaseUrl: process.env.VUE_APP_PROJECT_BASE_URL,
    };
  },
  components: {
    Captcha,
    Password,
  },
  created() {
    let getPhoneCodeTime = localStorage.getItem("getPhoneCodeTime");
    getPhoneCodeTime && this.tackBtn(getPhoneCodeTime);
    if (
      this.$GLOBAL.projectBaseUrl.search("localhost") != -1 ||
      this.$GLOBAL.projectBaseUrl.search("127.0.0.1") != -1
    ) {
      // this.activeName = "first";
      // this.isShowSmsLoginTab = false;
    }
  },
  computed: {
    phoneDisabled() {
      let { user, pass } = this.phoneRuleForm;
      if (user && pass) {
        return false;
      }
      return true;
    },
  },
  mounted() {
    window.sessionStorage.removeItem("phoneCodeToken");
    this.getCaptcha();
    this.init();
    //测试时 数据
  },
  methods: {
    init() {
      if (document.querySelector(".dynamic-gradient"))
        document.querySelector(".dynamic-gradient").onmousemove = (e) => {
          const x = e.pageX - e.target.getBoundingClientRect().x;
          const y = e.pageY - e.target.getBoundingClientRect().y;
          e.target.style.setProperty("--x", `${x}px`);
          e.target.style.setProperty("--y", `${y}px`);
        };
      if (document.querySelector(".dynamic-gradient2"))
        document.querySelector(".dynamic-gradient2").onmousemove = (e) => {
          const x = e.pageX - e.target.getBoundingClientRect().x;
          const y = e.pageY - e.target.getBoundingClientRect().y;
          e.target.style.setProperty("--x", `${x}px`);
          e.target.style.setProperty("--y", `${y}px`);
        };
    },
    // 聚焦哪一个表单组件，如果聚焦的是表单提交按钮，那么直接提交表单【enter键可以触发，方向键不能触发】。
    focusOn(value) {
      isBlur = false;
      switch (value) {
        case 1:
          this.$refs.accountInput.focus();
          break;
        case 2:
          this.$refs.passwordInput.focus();
          break;
        case 3:
          this.$refs.vCode1.focus();
          break;
        case 4:
          this.submitForm("ruleForm");
          break;
        case 5:
          this.$refs.phoneNumberInput.focus();
          break;
        case 6:
          this.$refs.shortMessageInput.focus();
          break;
        case 7:
          // 如果这时随机验证码验证已通过，并且随机验证码输入框被设置为禁用状态（避免等待短信验证码期间随机验证码失效，导致用户又得输入一次随机验证码），那么就直接提交表单。
          if (this.disabled2) {
            this.submitForm("phoneRuleForm");
          } else {
            this.$refs.vCode2.focus();
          }
          break;
        case 8:
          this.submitForm("phoneRuleForm");
          break;
        default:
          break;
      }
    },
    //获取随机验证码
    getCaptcha() {
      let that = this;
      getCaptchaCode().then((res) => {
        if (res.data.repData.originalImageBase64 && res.data.repData.token) {
          this.captchaImage =
            "data:image/png;base64," + res.data.repData.originalImageBase64;
          window.sessionStorage.setItem(
            "phoneCodeToken",
            res.data.repData.token
          );

          that.expirationPrompt = false;
          clearTimeout(that.expirationTimer);
          that.expirationTimer = setTimeout(() => {
            that.expirationPrompt = true;
            clearTimeout(that.expirationTimer);
          }, 120000); //和后端约定120秒算过期。
        } else {
          this.$alert("获取随机验证码发生了错误。", "友情提示", {
            confirmButtonText: "确定",
            type: "error",
            callback: (action) => {
              location.reload(); //刷新当前页面
            },
          });
          return false;
        }
      });
    },
    // 切换验证码
    refreshCode() {
      this.getCaptcha();
    },
    //验证随机验证码
    verifyCaptcha(formName) {
      //return true;
      let captchaCode;
      let inputRef;
      if (formName === "ruleForm") {
        captchaCode = this.ruleForm.verifycode;
        inputRef = "vCode1";
      } else {
        captchaCode = this.phoneRuleForm.verifycode2;
        inputRef = "vCode2";
      }
      let tempdata = {
        captchaType: "string",
        captchaCode: captchaCode,
        token: window.sessionStorage.getItem("phoneCodeToken"),
      };
      let that = this;
      return checkCaptchaCode(tempdata).then((res) => {
        //if (!res.data.success) {
        if (res.data.repCode === "0000") {
          return true;
        } else {
          if (!res.data.repMsg) {
            res.data.repMsg = "随机验证码验证失败。";
          }
          this.$alert(res.data.repMsg, "友情提示", {
            confirmButtonText: "确定",
            type: "error",
            callback: (action) => {
              //this.$refs[inputRef].focus();
              if (inputRef === "vCode1") {
                this.focusOn(2); //为避免按Enter键重复触发弹窗报错说验证码错误，所以这里聚焦到验证码输入框前一个控件，这样按了Enter键后正好能够聚焦到验证码输入框，而非重复报错。
              } else {
                this.focusOn(6);
              }
              this.refreshCode(); //刷新当前页面
            },
          });
          return false;
        }
      });
      //return rBool;
    },
    //密码的隐藏和显示
    showPass() {
      //点击图标是密码隐藏或显示
      if (this.passw == "text") {
        this.passw = "password";
        //更换图标
        this.icon = "el-input__icon el-icon-view";
      } else {
        this.passw = "text";
        this.icon = "el-input__icon el-icon-loading";
        setTimeout(() => {
          this.icon = "";
        }, 500);
      }
    },
    phoneShowPass() {
      //点击图标是密码隐藏或显示
      if (this.phoneRuleFormPassw == "text") {
        this.phoneRuleFormPassw = "password";
        //更换图标
        this.phoneIcon = "el-input__icon el-icon-view";
      } else {
        this.phoneRuleFormPassw = "text";
        this.phoneIcon = "el-input__icon el-icon-loading";
        setTimeout(() => {
          this.phoneIcon = "";
        }, 500);
      }
    },
    //密码失焦事件
    onBlur() {
      isBlur = true;
      this.passw = "password";
      this.icon = "el-input__icon el-icon-view";
    },
    phoneOnBlur() {
      this.phoneRuleFormPassw = "password";
      this.phoneIcon = "el-input__icon el-icon-view";
    },
    submitForm(formName) {
      let _this = this;
      isBlur = false;
      if (formName === "ruleForm") {
        // localStorage.setItem("activeName", "first");
        //先做表单必填项和输入规则验证【不涉及到请求后台】。
        _this.$refs[formName].validate((valid) => {
          if (valid) {
            //再做验证码验证【涉及到请求后台】。
            let result = _this.verifyCaptcha("ruleForm");
            result.then(function (resBool) {
              //console.log(data)
              if (resBool) {
                let data = {
                  account: _this.ruleForm.user,
                  password: _this.ruleForm.pass,
                  loginType: "account",
                  phone: "填充值，以便能通过后端接口验证。",
                  phoneCode: "填充值，以便能通过后端接口验证。",
                };
                userLoginAPI(data)
                  .then((res) => {
                    if (res.data.success && res.data.data) {
                      $cutscenes.continuation();

                      localStorage.removeItem("getPhoneCodeTime");
                      //改为直接从response.headers里获取token和refreshToken并存储在sessionStorage里。
                      //window.sessionStorage.setItem('token', res.data.data);
                      _this.storeProjects(_this);
                    } else {
                      _this.$alert(
                        "请核对您的用户名和密码，谢谢。",
                        "登录失败",
                        {
                          confirmButtonText: "确定",
                          type: "warning",
                          callback: (action) => {
                            //因为验证一次不通过后验证码就失效了，所以这里自动刷新验证码避免用户还得再手动刷新一次验证码。
                            _this.refreshCode();
                          },
                        }
                      );
                      return false;
                    }
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              }
            });
          }
        });
      } else {
        // //存储登录方式的个人习惯，因为此数据不必要，所以可以存储在localstorage里，就算浏览器隐身模式下localstorage不能正常读取也问题不大。
        // localStorage.setItem("activeName", "second");

        // //先做表单必填项和输入规则验证【不涉及到请求后台】。
        // _this.$refs[formName].validate((valid) => {
        //   if (valid) {
        //     //console.log('通过第1个');
        //     //再做验证码验证【涉及到请求后台】。
        //     //发短信验证码前已经验证了一次随机验证码，提交表单时若再验证一次随机验证码会提示随机验证码失效，这样的话用户又得填一次新的随机验证码，因此提交表单时就不需要在此再验证一次随机验证码了。
        //     //如果用户填写短信验证码后第一次提交表单则不再验证随机验证码，如果用户填入了错误的短信验证码则需要再次验证随机验证码。
        //     let data = {
        //       account: "填充值，以便能通过后端接口验证。",
        //       password: "填充值，以便能通过后端接口验证。",
        //       loginType: "phone",
        //       phone: _this.phoneRuleForm.phone,
        //       phoneCode: _this.phoneRuleForm.phoneCode,
        //     };
        //     if (_this.disabled2) {
        //       userLoginAPI(data)
        //         .then((res2) => {
        //           //console.log('通过第4个');
        //           if (res2.data.success && res2.data.data) {
        //             //console.log('通过第5个');
        //             //_this.$message.success("登录成功!");
        //             // _this.$message({
        //             //   message: "登录成功!",
        //             //   type: "success",
        //             //   offset: 100,
        //             //   showClose: true,
        //             //   duration: 1600,
        //             // });
        //             // window.sessionStorage.setItem('token', res2.data.data);
        //             localStorage.removeItem("getPhoneCodeTime");
        //             _this.storeProjects(_this);
        //           } else {
        //             _this.disabled2 = false; //提交表单验证失败后则刷新随机验证码，让用户再填写。
        //             _this.$alert(
        //               "请核对您的手机号和短信验证码，谢谢。",
        //               "登录失败",
        //               {
        //                 confirmButtonText: "确定",
        //                 type: "warning",
        //                 callback: (action) => {
        //                   //因为验证一次不通过后验证码就失效了，所以这里自动刷新验证码避免用户还得再手动刷新一次验证码。
        //                   _this.refreshCode();
        //                 },
        //               }
        //             );
        //             return false;
        //           }
        //         })
        //         .catch((err) => {
        //           console.log(err);
        //         });
        //     } else {
        //       let result = _this.verifyCaptcha("phoneRuleForm");
        //       result.then(function(resBool) {
        //         if (resBool) {
        //           userLoginAPI(data)
        //             .then((res2) => {
        //               //console.log('通过第4个');
        //               if (res2.data.success && res2.data.data) {
        //                 //console.log('通过第5个');
        //                 //_this.$message.success("登录成功!");
        //                 // _this.$message({
        //                 //   message: "登录成功!",
        //                 //   type: "success",
        //                 //   offset: 100,
        //                 //   showClose: true,
        //                 //   duration: 1600,
        //                 // });
        //                 // window.sessionStorage.setItem('token', res2.data.data);
        //                 localStorage.removeItem("getPhoneCodeTime");
        //                 _this.storeProjects(_this);
        //               } else {
        //                 _this.disabled2 = false; //提交表单验证失败后则刷新随机验证码，让用户再填写。
        //                 _this.$alert(
        //                   "请核对您的手机号和短信验证码，谢谢。",
        //                   "登录失败",
        //                   {
        //                     confirmButtonText: "确定",
        //                     type: "warning",
        //                     callback: (action) => {
        //                       //因为验证一次不通过后验证码就失效了，所以这里自动刷新验证码避免用户还得再手动刷新一次验证码。
        //                       _this.refreshCode();
        //                     },
        //                   }
        //                 );
        //                 return false;
        //               }
        //             })
        //             .catch((err) => {
        //               console.log(err);
        //             });
        //         }
        //       });
        //     }
        //   }
        // });

        //3月7号新加短信验证登录
        _this.$refs[formName].validate((valid) => {
          if (valid) {
            let data;
            // getSmsCaptcha(obj).then((res) => {
            // if (res.data.repCode === "0000") {
            //        user: "",
            // pass: "",
            // phoneCode: "",
            if (this.phoneNumber) {
              data = {
                account: this.phoneRuleForm.user,
                password: this.phoneRuleForm.pass,
                loginType: "phone",
                phone: this.phoneNumber,
                phoneCode: this.phoneRuleForm.phoneCode,
              };
              console.log(data);
            } else {
              this.$message({
                message: "请获取验证码",
                type: "error",
                showClose: true,
                duration: 1600,
              });
              return false;
            }

            userLoginAPI(data)
              .then((res) => {
                console.log(res, "resres");
                if (res.data.success && res.data.data) {
                  $cutscenes.continuation();
                  localStorage.removeItem("getPhoneCodeTime");
                  //改为直接从response.headers里获取token和refreshToken并存储在sessionStorage里。
                  //window.sessionStorage.setItem('token', res.data.data);
                  _this.storeProjects(_this);
                } else {
                  _this.$alert(res.data.message, "登录失败", {
                    confirmButtonText: "确定",
                    type: "warning",
                  });
                  return false;
                }
              })
              .catch((err) => {
                console.log(err);
              });

            // });
          }
        });
      }
    },
    async storeProjects(_this) {
      // await getLoginUser({
      //   appType: 1,
      // }).then((resL) => {
      //   if (resL.data.success && resL.data.data) {
      //     //let loginAccount=resL.data.data.account; //存放用户账户名。
      //     let loginAccount = resL.data.data.name; //（改为）存放用户真实姓名。
      //     if (loginAccount) {
      //       // window.sessionStorage.setItem("loginAccount", loginAccount);
      //       // window.sessionStorage.setItem(
      //       //   "posCode",
      //       //   resL.data.data.loginEmpInfo.positions[0].posCode
      //       // );
      //     }
      //   }
      // });
      getUserProjects().then((res2) => {
        // console.log(JSON.parse(JSON.stringify(res2)));
        // console.log(33333333333333);
        if (res2.data.data && res2.data.data.length > 0) {
          let projectInfoArr = res2.data.data;
          //综合考虑，这里暂时用sessionStorage来存储项目列表数据。

          // 使 单项目账号 进入项目列表页时遍历数组不出错。
          if (projectInfoArr.length === 1) {
            projectInfoArr = [...projectInfoArr];
          }
          // console.log(projectInfoArr);
          // return false;

          window.sessionStorage.setItem(
            "projectInfoArrJson",
            JSON.stringify(_this.unique(projectInfoArr, "id"))
          );
          // if (projectInfoArr.length === 1) {
          //   // 如果只有一个项目，则直接跳转到主控制台。
          //   window.sessionStorage.setItem(
          //     "nowProjectId",
          //     projectInfoArr[0]["id"]
          //   );
          //   _this.$router.push({
          //     path: "/index",
          //     // query: {
          //     // 	id: projectInfoArr[0]['id']
          //     // }
          //   });
          //   //location.reload(); //刷新当前页面
          // } else {
          _this.$router.push({
            path: "/projectsList",
          });
          //   //location.reload(); //刷新当前页面
          // }
          // console.log(JSON.parse(JSON.stringify(window.sessionStorage.getItem("projectInfoArrJson"))));
          // return false;
        } else {
          _this.$message.error("此账号下暂时没有可以查看的项目，请联系我们!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //切换Tab页触发方法。
    handleClick(tab, event) {
      this.refreshCode();
      if (tab.name === "first") {
        //alert(1)
        this.$nextTick(() => {
          this.$refs.accountInput.focus();
        });
      } else if (tab.name === "second") {
        //alert(2)
        this.$nextTick(() => {
          this.$refs["phoneNumberInput"].focus();
        });
      }
      // console.log(tab, event);
      // console.log(JSON.parse(JSON.stringify(tab._data)));
      // console.log(JSON.parse(JSON.stringify(tab._props)));
      // console.log(tab.index);
      // console.log(tab.name);
    },

    //获取手机验证码
    getCode() {
      // let data = {
      //   account: "填充值，以便能通过后端接口验证。",
      //   password: "填充值，以便能通过后端接口验证。",
      //   loginType: "phone",
      //   phone: Number(this.phoneRuleForm.phone),
      //   phoneCode: "填充值，以便能通过后端接口验证。",
      // };
      if (this.phoneDisabled) {
        this.$message({
          message: "请填写账号，密码",
          type: "error",
          showClose: true,
          duration: 1600,
        });
        return false;
      }
      let data = {
        account: this.phoneRuleForm.user,
        password: this.phoneRuleForm.pass,
      };

      getPhoneSmsCaptcha(data)
        .then((res) => {
          let { data, success, code, message } = res.data;
          console.log(success, code);
          if (success && code === 200) {
            this.phoneNumber = data.phone;
            this.$message({
              message: `已向手机：${data.phone.replace(
                data.phone.substr(3, 4),
                "****"
              )} 发送验证码`,
              type: "success",
              showClose: true,
              duration: 1600,
            });
            this.tackBtn();
          } else {
            console.log(message);
            this.$message({
              message: message,
              type: "error",
              showClose: true,
              duration: 1600,
            });
          }
        })
        .catch((err) => {
          this.$message({
            message: "短信发送失败，请稍后再试或者联系管理员",
            type: "error",
            showClose: true,
            duration: 1600,
          });
        });
    },
    changePhone(e) {
      var re = /^1[3,4,5,6,7,8,9][0-9]{9}$/;
      var result = re.test(e);
      if (!result || this.nowTime != 120) {
        this.disabled = true;
        console.log(111111111);
      } else {
        this.disabled = false;
        console.log("************");
      }
    },
    tackBtn(getPhoneCodeTimeVal = new Date().getTime() + 120000) {
      //验证码倒数120秒
      this.nowTime = 120;

      let getPhoneCodeTime = Number(getPhoneCodeTimeVal);
      if (getPhoneCodeTime > 0) {
        let timeLeft = Math.ceil(
          (getPhoneCodeTime - new Date().getTime()) / 1000
        );
        if (timeLeft > 0) {
          if (timeLeft > 120) {
            timeLeft = 120;
          }
          this.nowTime = timeLeft; //重置剩余时间
        }
      }

      // 避免一秒钟延迟，所以先运行一次。
      this.disabled = true;
      this.valiBtn = this.nowTime + "秒后重试";
      this.nowTime--;
      this.codeTimer = setInterval(() => {
        //if (time == 0) {
        if (this.nowTime < 1) {
          clearInterval(this.codeTimer);
          this.valiBtn = "获取短信验证码";
          this.disabled = false;
          localStorage.removeItem("getPhoneCodeTime");
        } else {
          this.disabled = true;
          this.valiBtn = this.nowTime + "秒后重试";
          this.nowTime--;
        }
      }, 1000);
    },

    //数组去重
    unique(arr, key) {
      let map = new Map();
      arr.forEach((item, index) => {
        if (!map.has(item[key])) {
          map.set(item[key], item);
        }
      });
      return [...map.values()];
    },
  },
  watch: {
    phoneRuleForm(newValue, oldValue) {
      console.log(newValue);
    },
  },
};
